import * as React from "react";

const defaultImg = require("../assets/default.jpg");

export interface PriceDefaultProps {}

const PriceDefault = (props: PriceDefaultProps) =>
  <div>
    <img className="img-responsive" src={defaultImg} />
  </div>;

export default PriceDefault;



// WEBPACK FOOTER //
// ./src/routes/Price/components/PriceDefault.tsx